import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { asyncQueue } from 'app/lib/asyncQueue';
import { useFeatureFlag } from 'app/lib/feature-flags';
import { ROUTE_PATH } from 'app/lib/routing/constants';
import { selectSignalrConnected } from 'app/lib/signalr';
import { TimeFilter } from 'app/modules/TimeFilter';
import { selectIsLoggedIn } from 'app/redux/selectors/auth';
import ErrorBoundary from 'app/widgets/ErrorBoundary';

import { FAVORITES, subscribeToFavorites, unsubscribeFromFavorites } from '../Favorites/actions';
import { matchIds } from '../Favorites/selectors/gridEntities';
import { Container } from './components/Container/Container';
import { BettingTypeSwitcher } from './submodules/BettingTypeSwitcher';
import { LiveMenu } from './submodules/LiveMenu';
import { PrematchMenu } from './submodules/PrematchMenu';

import styles from './BettingMenu.module.scss';

export const BettingMenu: React.FC = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const favoriteMatchIds = useSelector(matchIds);
  const signalrConnected = useSelector(selectSignalrConnected);
  const isPrematch = pathname.startsWith(ROUTE_PATH.PREMATCH);
  const hasTimeFilter = useFeatureFlag(FeatureFlag.TIME_FILTER);

  useEffect(() => {
    return () => {
      asyncQueue.removeFromQueue(FAVORITES, () => dispatch(unsubscribeFromFavorites()));
    };
  }, []);

  useEffect(() => {
    if (signalrConnected && isLoggedIn && !favoriteMatchIds.size) {
      asyncQueue.addToQueue(
        FAVORITES,
        () => dispatch(subscribeToFavorites()),
      );
    }
  }, [signalrConnected]);

  useEffect(() => {
    if (!isLoggedIn && favoriteMatchIds.size) {
      asyncQueue.removeFromQueue(
        FAVORITES,
        () => dispatch(unsubscribeFromFavorites()),
      );
    }
  }, [isLoggedIn]);

  return (
    <Container>
      <ErrorBoundary>
        <BettingTypeSwitcher />
        {hasTimeFilter && isPrematch && <TimeFilter className={styles.timeFilter} />}
        {isPrematch ? <PrematchMenu /> : <LiveMenu />}
      </ErrorBoundary>
    </Container>
  );
};
